require('./bootstrap');
require('./common/not_double_submit').default();
require('./common/collapse').default();
